import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */
/* @jsx mdx */
import DefaultLayout from "/opt/atlassian/pipelines/agent/build/platform/services/design-system-docs/src/__DO_NOT_ADD_TO_THIS_FOLDER__/gatsby-theme-brisk/templates/page.tsx";
export const _frontmatter = {};
const layoutProps = {
  _frontmatter
};
const MDXLayout = DefaultLayout;
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">


    <h2 {...{
      "id": "atlassian-design-system"
    }}>{`Atlassian Design System`}</h2>
    <h3 {...{
      "id": "1-license-grant"
    }}>{`1. License Grant`}</h3>
    <p>{`Subject to the terms of this License Agreement, Atlassian Pty Ltd (“Atlassian”) grants you a
limited, worldwide, royalty-free, non-assignable, non-sublicensable, and non-exclusive license to
use the Atlassian Design System, including documentation, visual assets, incorporated libraries,
plugins, sticker sheets, code packages, and migration tooling (collectively, "ADS"), as made
available by Atlassian through its website and other services
at `}<a parentName="p" {...{
        "href": "https://atlassian.design/"
      }}>{`https://atlassian.design/`}</a>{` (collectively, “Services”), in connection with creating, testing,
otherwise using, and distributing plugins, extensions, add-ons or other software products or
services that interoperate or are integrated with Atlassian’s software and cloud products and apps
("Add-Ons").`}</p>
    <h3 {...{
      "id": "2-license-restrictions"
    }}>{`2. License Restrictions`}</h3>
    <p>{`You may not use the ADS for any purpose not expressly permitted by this License Agreement. In
addition, you may not, and must not permit any third party to:`}</p>
    <ul>
      <li parentName="ul">{`(a) modify or adapt all or any portion of the ADS and Services;`}</li>
      <li parentName="ul">{`(b) decompile, disassemble, or otherwise reverse engineer the ADS or Services, or any portion
thereof, or determine or attempt to seek to access any source code, algorithms, methods, or
techniques used or embodied in the ADS or Services or any portion thereof;`}</li>
      <li parentName="ul">{`(c) modify, translate, or create any derivative works based upon the ADS or Services;`}</li>
      <li parentName="ul">{`(d) distribute or transfer the ADS or Services, in whole or in part, to any third party; and`}</li>
      <li parentName="ul">{`(e) remove or alter any copyright, trademark, or other proprietary notices, legends, symbols, or
labels appearing on or in the ADS or Services.`}</li>
    </ul>
    <h3 {...{
      "id": "3-ip-ownership-in-ads"
    }}>{`3. IP Ownership in ADS`}</h3>
    <p>{`Atlassian or its licensors own all legal right, title, and interest in and to the ADS and Services
and any portion thereof, including any Intellectual Property Rights that subsist in the ADS and
Services. "Intellectual Property Rights" means any and all rights under patent law, copyright law,
trade secret law, trademark law, and any and all other proprietary rights.`}</p>
    <p>{`Atlassian reserves all rights not expressly granted to you. You must not take any action to
jeopardize, encumber, limit, or interfere in any manner with Atlassian or its licensors’ ownership
of and rights with respect to the ADS or Services, or any derivative works thereof.`}</p>
    <h3 {...{
      "id": "4-term-and-termination"
    }}>{`4. Term and Termination`}</h3>
    <p>{`Atlassian may terminate this Agreement: (a) if you breach any of the terms of this Agreement or (b)
if Atlassian ceases to offer the ADS generally. You may also terminate this Agreement at any time.
Upon termination, your rights granted under this Agreement will end.`}</p>
    <p>{`This means that you must cease using the ADS and delete all copies of the ADS. In the event of
termination, you agree that Atlassian shall be entitled to injunctive and other appropriate
equitable relief (without the necessity of proving actual damages or of posting a bond), and that
everything in this Agreement other than your license right will survive this Agreement’s
termination.`}</p>
    <p>{`For the avoidance of doubt, you may continue to distribute Add-Ons that you developed under this
Agreement prior to termination.`}</p>
    <h3 {...{
      "id": "5-no-warranty"
    }}>{`5. No Warranty`}</h3>
    <p>{`The ADS and services are provided “as is” and “with all faults”. Atlassian and its third party
licensors disclaim all representations, warranties, and guarantees with respect to the ADS, the
Services, or any other subject matter of this Agreement, whether express, implied, or statutory,
including implied warranties of merchantability, title, non-infringement, and fitness for any
purpose, or other warranties that may arise for course of dealing, course of performance, or usage
of trade.`}</p>
    <p>{`Atlassian makes no representation, warranty, or guarantee related to reliability, accuracy, or
completeness of the ADS or Services, or that your use of the ADS or Services will be secure, timely,
uninterrupted, or error-free. The ADS or Services may not meet your requirements or expectations.`}</p>
    <p>{`No oral or written information or advice provided by Atlassian, its agents, or its employees, shall
create any warranty contrary to this Agreement.`}</p>
    <h3 {...{
      "id": "6-limitation-of-liability"
    }}>{`6. Limitation of Liability`}</h3>
    <p>{`In no event shall Atlassian be liable for any damages for loss of profits or revenue, loss of
business, loss of use or data, failure of security mechanisms, interruption of business, or any
indirect, special, incidental, consequential, or punitive damages of any kind (or other economic
loss, including from lost profits or lost data), regardless of the form of action, whether in
contract, tort (including negligence), strict liability or otherwise, even if informed of the
possibility of such damages in advance, however caused.`}</p>
    <p>{`Atlassian shall not be liable for any damages that you may suffer in connection with failure in the
performance of the ADS or the Services. Notwithstanding any other provision of this Agreement,
Atlassian’s entire liability to you under this Agreement shall not exceed five hundred US dollars
($500).`}</p>
    <p>{`The above warranty disclaimers and limitations of liability apply to the maximum extent permitted by
law, but you may have other statutory rights, which this Agreement cannot change.`}</p>
    <p>{`The limitations in this Section 6 will survive and apply even if any limited remedy specified in
this Agreement is found to have failed of its essential purpose.`}</p>
    <h3 {...{
      "id": "7-responsibility-for-your-add-ons-indemnification"
    }}>{`7. Responsibility for your Add-Ons; Indemnification`}</h3>
    <p>{`You are solely responsible for your Add-Ons, your use of the ADS or Services, and your compliance
with this Agreement.`}</p>
    <p>{`You agree to indemnify, defend and hold Atlassian harmless from and against any and all claims,
costs, damages, losses, liabilities and expenses (including reasonable attorneys’ fees and costs)
arising out of any claim relating to:`}</p>
    <ul>
      <li parentName="ul">{`(a) your use of the ADS or Services,`}</li>
      <li parentName="ul">{`(b) your use, operation, or combination of the ADS or Services with non-Atlassian programs, data,
equipment, or documentation if liability would have been avoided but for such use, operation, or
combination,`}</li>
      <li parentName="ul">{`(c) your use of other than the then-current, unaltered version of the ADS or Services,`}</li>
      <li parentName="ul">{`(d) any modifications to or markings of the ADS or Services that are not specifically authorized
in writing by Atlassian, or`}</li>
      <li parentName="ul">{`(e) your breach of this Agreement.`}</li>
    </ul>
    <p>{`Atlassian may participate in defending the claim at its own expense. You may not settle any claim
without Atlassian’s prior written consent.`}</p>
    <h3 {...{
      "id": "8-open-source-software"
    }}>{`8. Open Source Software`}</h3>
    <p>{`Certain distributed code in the ADS may be licensed under or include components subject to "open
source" software terms ("`}<strong parentName="p">{`OSS`}</strong>{`").`}</p>
    <p>{`To the extent applicable, Atlassian will identify OSS included in the ADS in or through the ADS
itself. The OSS licenses may grant you additional rights to the OSS code itself and allow you to use
the OSS outside of the ADS. However, when you use the ADS as part of the Developer Platform, you
must comply with this License Agreement.`}</p>
    <h3 {...{
      "id": "9-general"
    }}>{`9. General`}</h3>
    <p>{`This Agreement will be governed by and construed in accordance with the laws of the State of
California, excluding conflicts of law rules and principles.`}</p>
    <p>{`Each party submits to the personal and exclusive jurisdiction of the federal or state courts located
in San Francisco County, California.`}</p>
    <p>{`Nothing in this Agreement limits Atlassian’s rights to seek equitable relief.`}</p>
    <p>{`Last updated: March 13, 2025.`}</p>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      